__webpack_require__.p = "https://static.moomoo.com/components/common-redpacket-share/";